import React, { useEffect, useMemo } from 'react';
import { BASETYPE_NAME_TO_VALUE } from '../../constants';
import { updatePartialState, usePartialState } from '../../store/state';
import { queryModelState } from '../../store/actions';
import { Filter } from '../base/Filter';
import { ModelList } from '../base/List';

export const History = React.memo(() => {
  const { filters, data } = usePartialState('checkpoint.history');

  const handleApplyFilter = (value) => {
    updatePartialState('checkpoint.history.filters', value);
  };

  const listData = useMemo(() => {
    const items = data.items.filter((item) => {
      if (filters.keyword) {
        const keyword = filters.keyword.toLowerCase();
        const targetString = `${item.name || ''}${item.userName || ''}`.toLowerCase();

        if (!targetString.includes(keyword)) {
          return false;
        }
      }

      if (filters.baseTypes?.length && !filters.baseTypes.includes(String(BASETYPE_NAME_TO_VALUE[item.baseType]))) {
        return false;
      }

      return true;
    });

    return { items, total: items.length, loading: data.loading, hasMore: data.hasMore };
  }, [data, filters]);

  useEffect(() => {
    queryModelState('checkpoint', 'history');
  }, []);

  return (
    <main className="flex flex-col flex-1 overflow-hidden">
      <div className="relative z-[5] px-5 py-2" style={{ boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.05)' }}>
        <Filter value={filters} onSubmit={handleApplyFilter} />
      </div>
      <div className="flex-1 px-5 overflow-auto tiny-scrollbar bg-[#f9fbfb]">
        <ModelList data={listData} showTag={!filters.keyword} from="history" />
      </div>
    </main>
  );
});
